import React from 'react';
import { CtaBlock } from '../CtaButton';
import { MockupCrop } from '../MockupCrop';
import { Accent, SectionHeading } from './SectionHeading';
import { volumes } from '../../data/content';

/** Section 5 — each core volume in detail. */
export function VolumesSection() {
  return <section aria-labelledby="volumes-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-245" data-mp="7z3t1b5kn142">
      <div className="mx-auto max-w-5xl" data-id="element-246" data-mp="vp7xfkql34w4">
        <SectionHeading id="volumes-heading" eyebrow="Inside the System" title={<>
              The 6 Core Volumes, <Accent data-id="element-248" data-mp="mww6lxrk5ffm">One by One.</Accent>
            </>} body="Each volume covers one stage of professional makeup education — and is built to be used in class, not just read." data-id="element-247" data-mp="vq9atvv2o3h0" />

        <ol className="mt-14 space-y-6" data-id="element-249" data-mp="1eo28ojqu9n7j">
          {volumes.map(volume => <li key={volume.number} data-id="element-250" data-mp="1elzeromkf9xj">
              <article className="grid gap-7 rounded-[24px] border border-brand-charcoal/8 bg-white p-5 shadow-[0_30px_60px_-44px_rgba(59,27,87,0.5)] sm:p-8 md:grid-cols-[230px_1fr] md:gap-10" data-id="element-251" data-mp="1jesefy36fs2r">
                <MockupCrop crop={volume.crop} alt={`Volume ${volume.number} cover — ${volume.title}`} className="mx-auto w-full max-w-[230px] self-start rounded-[14px] shadow-[0_24px_40px_-24px_rgba(59,27,87,0.5)]" data-id="element-252" data-mp="7my3l8792zmu" />

                <div data-id="element-253" data-mp="vb7v8qr5ahlw">
                  <p className="flex items-baseline gap-3" data-id="element-254" data-mp="vapt5dhsx962">
                    <span className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-charcoal/50" data-id="element-255" data-mp="ra5s3yu3xlen">
                      Volume {volume.number}
                    </span>
                    <span className="font-display text-[1.6rem] font-bold italic leading-none text-brand-berry" data-id="element-256" data-mp="10au7oxz5fttn">
                      {volume.stage}.
                    </span>
                  </p>
                  <h3 className="mt-3 font-display text-[1.7rem] font-bold leading-[1.1] text-brand-charcoal sm:text-[2rem]" data-id="element-257" data-mp="322738wf88pd1">
                    {volume.title}
                  </h3>
                  <p className="mt-2 text-[15px] leading-relaxed text-brand-charcoal/65" data-id="element-258" data-mp="161f16f07flq3">{volume.subtitle}</p>

                  <p className="mt-6 font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-charcoal/45" data-id="element-259" data-mp="1ezqqmdpc4dgy">
                    Key contents
                  </p>
                  <p className="mt-2 text-[14px] leading-relaxed text-brand-charcoal/75" data-id="element-260" data-mp="1jwqwani9ve7j">{volume.contents}</p>

                  <div className="mt-6 rounded-[14px] bg-brand-lavender px-5 py-4" data-id="element-261" data-mp="1ow3qjtbh3nk5">
                    <p className="font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-plum" data-id="element-262" data-mp="1tuwuov4ve27n">
                      How this helps you teach
                    </p>
                    <p className="mt-1.5 text-[15px] font-medium leading-snug text-brand-charcoal" data-id="element-263" data-mp="22ojo4ellutdo">{volume.benefit}</p>
                  </div>
                </div>
              </article>
            </li>)}
        </ol>

        <CtaBlock label="Get the Complete 6-Volume System — $27" className="mt-14" data-id="element-264" data-mp="2mrfvvd5xrns1" />
      </div>
    </section>;
}